import AnalyticsEventsAPI from 'dashboard/api/analyticsEvents';

export const trackCrmEvent = async ({
  accountId,
  name,
  properties = {},
  source = 'dashboard_doc20',
}) => {
  try {
    await AnalyticsEventsAPI.create({
      account_id: accountId,
      name,
      source: 'web',
      properties: {
        source,
        ...properties,
      },
    });
    return true;
  } catch {
    return false;
  }
};

export const trackCrmParityEvents = async ({
  accountId,
  names = [],
  properties = {},
}) => {
  const events = Array.isArray(names) ? names : [names];
  await Promise.all(
    events.filter(Boolean).map(name =>
      trackCrmEvent({
        accountId,
        name,
        properties,
        source: 'quinto_parity',
      })
    )
  );
};
